import './style.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)',
).matches;

function createSprite(container) {
  const imageSrc = container.getAttribute('data-image');
  const widthFrame = parseInt(container.getAttribute('data-frame-width'), 10);
  const heightFrame = parseInt(container.getAttribute('data-frame-height'), 10);
  const steps = parseInt(container.getAttribute('data-steps'), 10);
  const fps = parseInt(container.getAttribute('data-fps'), 10);
  const loop = container.getAttribute('data-loop') === 'true';

  if (
    !imageSrc ||
    isNaN(widthFrame) ||
    isNaN(heightFrame) ||
    isNaN(steps) ||
    isNaN(fps)
  )
    return null;

  const spriteImage = document.createElement('img');
  spriteImage.src = imageSrc;
  spriteImage.alt = '';
  spriteImage.setAttribute('role', 'presentation');
  spriteImage.setAttribute('aria-hidden', 'true');
  spriteImage.style.width = `${widthFrame * steps}px`;
  spriteImage.style.height = `${heightFrame}px`;
  spriteImage.style.position = 'absolute';
  spriteImage.style.top = '0';
  spriteImage.style.left = '0';

  const spriteWrapper = document.createElement('div');
  spriteWrapper.style.position = 'relative';
  spriteWrapper.style.width = `${widthFrame}px`;
  spriteWrapper.style.height = `${heightFrame}px`;
  spriteWrapper.style.overflow = 'hidden';

  spriteWrapper.appendChild(spriteImage);
  container.appendChild(spriteWrapper);

  if (prefersReducedMotion) {
    spriteImage.style.transform = `translateX(-${widthFrame * (steps - 1)}px)`;
    return { play: () => {}, reset: () => {}, stop: () => {} };
  }

  const duration = steps / fps;
  let animation = gsap.fromTo(
    spriteImage,
    { x: 0 },
    {
      x: -widthFrame * (steps - 1),
      duration,
      ease: `steps(${steps - 1})`,
      repeat: loop ? -1 : 0,
      paused: true,
    },
  );

  return {
    play: () => animation.restart(),
    reset: () => {
      animation.pause();
      gsap.set(spriteImage, { x: 0 });
    },
    stop: () => animation.kill(),
  };
}

export function initSprites() {
  const spriteAnimations = [];
  const spriteContainers = document.querySelectorAll('.sprite');
  var hasTouch = false;

  spriteContainers.forEach(container => {
    const controls = createSprite(container);
    if (!controls) return;
    spriteAnimations.push({ controls, container });

    const hoverTargetSelector = container.getAttribute('data-hover-target');

    if (hoverTargetSelector && hoverTargetSelector !== 'false') {
      const target = container.closest(hoverTargetSelector) || container;
      target.addEventListener('touchstart', () => hasTouch=true);
      target.addEventListener('touchmove', () => {});
      target.addEventListener('mouseenter', () => !hasTouch && controls.play());
      target.addEventListener('mouseleave', () => !hasTouch && controls.reset());
    } else {
      ScrollTrigger.create({
        trigger: container,
        start: 'top 80%',
        onEnter: () => {
          if (container.getAttribute('data-autoplay') !== 'false') {
            controls.play();
          }
        },
        once: true,
      });
    }
  });
  window.spriteAnimations = spriteAnimations;
}

document.addEventListener('DOMContentLoaded', initSprites);
